import { render, staticRenderFns } from "./CollectionConfigurationsForm.vue?vue&type=template&id=5ad2e4ae&scoped=true&"
import script from "./CollectionConfigurationsForm.vue?vue&type=script&lang=js&"
export * from "./CollectionConfigurationsForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionConfigurationsForm.vue?vue&type=style&index=0&id=5ad2e4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2e4ae",
  null
  
)

export default component.exports